
import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface GrowthIndicatorProps {
  growth: number;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const GrowthIndicator: React.FC<GrowthIndicatorProps> = ({ 
  growth, 
  label = 'к прошлому месяцу',
  size = 'md' 
}) => {
  const getGrowthColor = () => {
    if (growth > 0) return 'text-green-600';
    if (growth < 0) return 'text-red-600';
    return 'text-gray-500';
  };

  const getGrowthIcon = () => {
    if (growth > 0) return TrendingUp;
    if (growth < 0) return TrendingDown;
    return Minus;
  };

  const getGrowthText = () => {
    if (growth === 0) return '0%';
    const sign = growth > 0 ? '+' : '';
    return `${sign}${growth.toFixed(1)}%`;
  };

  const getSizeClass = () => {
    switch (size) {
      case 'sm': return 'text-xs';
      case 'lg': return 'text-base';
      default: return 'text-sm';
    }
  };

  const getIconSize = () => {
    switch (size) {
      case 'sm': return 'h-3 w-3';
      case 'lg': return 'h-5 w-5';
      default: return 'h-4 w-4';
    }
  };

  const Icon = getGrowthIcon();

  return (
    <div className={`flex items-center gap-1 ${getSizeClass()} ${getGrowthColor()}`}>
      <Icon className={getIconSize()} />
      <span className="font-medium">{getGrowthText()}</span>
      <span className="text-muted-foreground">{label}</span>
    </div>
  );
};
